var map = {
	"./en-US": [
		"J5vx",
		0,
		1
	],
	"./en-US/": [
		"J5vx",
		0,
		1
	],
	"./en-US/index": [
		"J5vx",
		0,
		1
	],
	"./en-US/index.js": [
		"J5vx",
		0,
		1
	],
	"./zh-CN": [
		"HknP",
		0,
		2
	],
	"./zh-CN/": [
		"HknP",
		0,
		2
	],
	"./zh-CN/index": [
		"HknP",
		0,
		2
	],
	"./zh-CN/index.js": [
		"HknP",
		0,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3ju1";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/locales/lang lazy ^\.\/.*$
// module id = 3ju1
// module chunks = 4